import * as yaml from "js-yaml";

export function downloadFile(
    fileName: string,
    mimeType: string,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    data: any,
): void {
    const blob =
        data instanceof Blob
            ? data
            : new Blob([yaml.dump(data)], {
                  type: mimeType,
              });
    const fileObjectURL = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    document.body.appendChild(a);
    a.href = fileObjectURL;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(fileObjectURL);
    a.remove();
}
